module.exports = __webpack_public_path__ + "img/logo-3dm-mobile-white.bf00aa07.svg";